// src/lib/fbGroups.js — which Facebook group a share opens in.
//
// Owner, 2026-09-02: "https://www.facebook.com/groups/1220324286439464/ this is [sentavus] land
// group on facebook. we use one other group as default one[;] lets make this for land reshare as
// default."
//
// ⚠️ ONE DEFINITION, because there are already two places that could hold it. The extension's
// background.js falls back to the apartments group when the Desk sends no `fbUrl`, and the
// posted-link capture separately tests `groupKey === "sentavusapartments"` to decide whether a
// post landed in OUR OWN group (which outranks a post in someone else's — a canonical-link
// rule). If the land group's address were written into the Desk inline, that second rule would
// keep reading land posts as somebody else's group forever. The addresses live here; the
// extension's own-group test is noted below as the thing that still has to learn about it.
//
// 🔴 OPEN, and stated rather than quietly half-done: the extension's own-group test names ONE
// group by slug. A land post in the group below is ours and will not be recognised as ours until
// that test takes this list instead. That is an extension change, and every zip in the field is
// older than the FB share feature anyway (measured 2026-09-02: ONE facebook activity event has
// ever been logged, on the build day), so it is filed with the rest of the distribution problem
// rather than pretended fixed here.

// A group is addressed by its numeric id or its slug; Facebook accepts both, and the slug is
// what the apartments group has always used — kept verbatim so the extension's own-group test
// keeps matching it exactly.
export const FB_GROUPS = {
  apartments: 'https://www.facebook.com/groups/sentavusapartments',
  land:       'https://www.facebook.com/groups/1220324286439464',
}

/**
 * Where a share of this property kind should open.
 * ⚠️ Land is the ONLY special case, deliberately: houses and commercial units are sold to the
 * same audience as apartments, and splitting them across groups would thin every group's reach
 * for no editorial reason. An unknown or missing kind gets the general group — a share that
 * opens in the wrong-but-populated group is recoverable, one that opens nowhere is not.
 */
export function fbGroupForKind(kind) {
  return kind === 'land' ? FB_GROUPS.land : FB_GROUPS.apartments
}
